import { ERROR, START, SUCCESS } from "../../../../constants/action-postfix";
import { STUDENTS_INFO_REQUEST } from "../studentsInfoReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STUDENTS_INFO_REQUEST}${START}`:
            return true;
        case `${STUDENTS_INFO_REQUEST}${SUCCESS}`:
            return false;
        case `${STUDENTS_INFO_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};
